// Il ponte con il compositore. Una funzione sola: markdown dentro, o un PDF
// o dei problemi fuori — mai un'eccezione da interpretare a valle.

export interface Problem
{
    line: number;
    message: string;
}


export interface Composed
{
    ok: true;
    pdf: Uint8Array<ArrayBuffer>;
    log: string;
}


export interface Failed
{
    ok: false;
    output: string;
    problems: Problem[];
}


export async function compose(markdown: string): Promise<Composed | Failed>
{
    let res: Response;
    try
    {
        res = await fetch("/api/compose", {
            method: "POST",
            headers: { "Content-Type": "text/markdown; charset=utf-8" },
            body: markdown,
        });
    }
    catch (err)
    {
        // Il server spento e' un caso normale, non un errore da stack trace:
        // si dice cosa manca e come si accende.
        return {
            ok: false,
            output: `il server non risponde (${String(err)}).\nAvvialo con \`npm run dev\`.`,
            problems: [],
        };
    }

    if (!res.ok)
    {
        const body = await res.json().catch(() => ({ output: `HTTP ${res.status}`, problems: [] }));
        return { ok: false, output: String(body.output ?? ""), problems: body.problems ?? [] };
    }

    const buffer = await res.arrayBuffer();
    const log = res.headers.get("X-Md2Pdf-Log");
    return {
        ok: true,
        pdf: new Uint8Array(buffer),
        log: log === null ? "" : new TextDecoder().decode(Uint8Array.from(atob(log), (c) => c.charCodeAt(0))),
    };
}
